import React from 'react';
import { Card, Skeleton, Space, Divider, Typography } from 'antd';

const { Text } = Typography;

const BrowseLotCardSkeleton = () => {
    return (
        <Card
            style={{
                borderRadius: '16px',
                overflow: 'hidden',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                border: '1px solid #e5e7eb',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
                background: '#ffffff'
            }}
            cover={
                <div style={{ 
                    position: 'relative',
                    height: 160,
                    background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    gap: '12px'
                }}>
                    <div style={{
                        width: '60px',
                        height: '60px',
                        borderRadius: '50%',
                        background: 'rgba(255, 255, 255, 0.2)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white',
                        fontSize: '28px',
                        fontWeight: 'bold',
                        backdropFilter: 'blur(10px)'
                    }}>
                        M
                    </div>
                    <Text style={{ 
                        fontSize: '14px', 
                        textAlign: 'center',
                        color: 'rgba(255, 255, 255, 0.9)',
                        fontWeight: 500
                    }}>
                        Meveshibids
                    </Text>
                    <div style={{
                        position: 'absolute',
                        top: 12,
                        right: 12,
                        zIndex: 1
                    }}>
                        <Skeleton.Button active style={{ 
                            width: '60px', 
                            height: '24px', 
                            borderRadius: '12px',
                            background: 'rgba(255, 255, 255, 0.3)',
                            border: 'none'
                        }} />
                    </div>
                </div>
            }
            bodyStyle={{ padding: '16px' }}
        >
            <div style={{ flex: 1 }}>
                <Space direction="vertical" size={12} style={{ width: '100%' }}>
                    {/* Lot Number and Category */}
                    <div>
                        <Skeleton.Input 
                            active 
                            style={{ 
                                width: '140px',
                                height: '12px',
                                marginBottom: '6px',
                                borderRadius: '4px',
                                background: '#f0f0f0',
                                border: 'none'
                            }} 
                        />
                        <Skeleton.Input 
                            active 
                            style={{ 
                                width: '90%',
                                height: '18px',
                                marginBottom: '4px',
                                borderRadius: '4px',
                                background: '#f0f0f0',
                                border: 'none'
                            }} 
                        />
                        <Skeleton.Input 
                            active 
                            style={{ 
                                width: '70%',
                                height: '18px',
                                borderRadius: '4px',
                                background: '#f0f0f0',
                                border: 'none'
                            }} 
                        />
                    </div>
                    
                    {/* Price and Quantity Grid */}
                    <div style={{ 
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        gap: '10px',
                        marginTop: '8px',
                        width: '100%',
                        overflow: 'hidden'
                    }}>
                        {/* Price Box Skeleton */}
                        <div style={{ 
                            background: '#f8fafc',
                            padding: '10px 12px',
                            borderRadius: '10px',
                            border: '1px solid #e2e8f0',
                            overflow: 'hidden',
                            width: '100%',
                            minWidth: 0
                        }}>
                            <Space size={6} style={{ width: '100%' }}>
                                <Skeleton.Avatar 
                                    active 
                                    size={16} 
                                    shape="circle"
                                    style={{
                                        background: '#e2e8f0',
                                        border: 'none',
                                        flexShrink: 0
                                    }}
                                />
                                <div style={{ flex: 1, minWidth: 0, overflow: 'hidden', width: '100%' }}>
                                    <Skeleton.Input 
                                        active 
                                        style={{ 
                                            width: '70px',
                                            maxWidth: '100%',
                                            height: '10px',
                                            marginBottom: '6px',
                                            borderRadius: '4px',
                                            background: '#e2e8f0',
                                            border: 'none'
                                        }} 
                                    />
                                    <Skeleton.Input 
                                        active 
                                        style={{ 
                                            width: '80px',
                                            maxWidth: '100%',
                                            height: '18px',
                                            borderRadius: '4px',
                                            background: '#e2e8f0',
                                            border: 'none'
                                        }} 
                                    />
                                </div>
                            </Space>
                        </div>

                        {/* Quantity Box Skeleton */}
                        <div style={{ 
                            background: '#f8fafc',
                            padding: '10px 12px',
                            borderRadius: '10px',
                            border: '1px solid #e2e8f0',
                            overflow: 'hidden',
                            width: '100%',
                            minWidth: 0
                        }}>
                            <Space size={6} style={{ width: '100%' }}>
                                <Skeleton.Avatar 
                                    active 
                                    size={16} 
                                    shape="circle"
                                    style={{
                                        background: '#e2e8f0',
                                        border: 'none',
                                        flexShrink: 0
                                    }}
                                />
                                <div style={{ flex: 1, minWidth: 0, overflow: 'hidden', width: '100%' }}>
                                    <Skeleton.Input 
                                        active 
                                        style={{ 
                                            width: '50px',
                                            maxWidth: '100%',
                                            height: '10px',
                                            marginBottom: '6px',
                                            borderRadius: '4px',
                                            background: '#e2e8f0',
                                            border: 'none'
                                        }} 
                                    />
                                    <Skeleton.Input 
                                        active 
                                        style={{ 
                                            width: '40px',
                                            maxWidth: '100%',
                                            height: '18px',
                                            borderRadius: '4px',
                                            background: '#e2e8f0',
                                            border: 'none'
                                        }} 
                                    />
                                </div>
                            </Space>
                        </div>
                    </div>

                    {/* Bids Tag Skeleton (optional, sometimes shown) */}
                    <div style={{ marginTop: '10px' }}>
                        <Skeleton.Button 
                            active 
                            style={{ 
                                width: '70px', 
                                height: '24px', 
                                borderRadius: '6px',
                                background: '#e2e8f0',
                                border: 'none'
                            }} 
                        />
                    </div>

                    {/* Action Buttons Skeleton */}
                    <div style={{ 
                        marginTop: '12px',
                        display: 'flex',
                        gap: '8px',
                        width: '100%'
                    }}>
                        {/* Auction Details Button Skeleton */}
                        <div style={{ 
                            flex: 1,
                            height: '36px',
                            borderRadius: '8px',
                            background: '#e2e8f0',
                            border: '1px solid #d1d5db',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '6px',
                            padding: '0 12px',
                            minWidth: 0
                        }}>
                            <Skeleton.Avatar 
                                active 
                                size={14} 
                                shape="circle"
                                style={{
                                    background: '#cbd5e1',
                                    border: 'none',
                                    flexShrink: 0
                                }}
                            />
                            <Skeleton.Input 
                                active 
                                style={{ 
                                    width: '80px',
                                    maxWidth: '100%',
                                    height: '12px',
                                    borderRadius: '4px',
                                    background: '#cbd5e1',
                                    border: 'none',
                                    flex: 1,
                                    minWidth: 0
                                }} 
                            />
                        </div>
                        
                        {/* Lot Details Button Skeleton */}
                        <div style={{ 
                            flex: 1,
                            height: '36px',
                            borderRadius: '8px',
                            background: '#e2e8f0',
                            border: 'none',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '6px',
                            padding: '0 12px',
                            minWidth: 0
                        }}>
                            <Skeleton.Avatar 
                                active 
                                size={14} 
                                shape="circle"
                                style={{
                                    background: '#cbd5e1',
                                    border: 'none',
                                    flexShrink: 0
                                }}
                            />
                            <Skeleton.Input 
                                active 
                                style={{ 
                                    width: '70px',
                                    maxWidth: '100%',
                                    height: '12px',
                                    borderRadius: '4px',
                                    background: '#cbd5e1',
                                    border: 'none',
                                    flex: 1,
                                    minWidth: 0
                                }} 
                            />
                        </div>
                    </div>

                    <Divider style={{ margin: '12px 0' }} />

                    {/* Company Information Section Skeleton */}
                    <div 
                        style={{
                            padding: '10px 12px',
                            background: '#f8fafc',
                            borderRadius: '8px',
                            border: '1px solid #e2e8f0'
                        }}
                    >
                        <Space size={10} style={{ width: '100%' }}>
                            <Skeleton.Avatar 
                                active 
                                size={32} 
                                shape="circle"
                                style={{
                                    background: '#e5e7eb',
                                    border: '2px solid #d1d5db',
                                    flexShrink: 0
                                }}
                            />
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <Skeleton.Input 
                                    active 
                                    style={{ 
                                        width: '100px',
                                        height: '12px',
                                        marginBottom: '4px',
                                        borderRadius: '4px',
                                        background: '#e5e7eb',
                                        border: 'none'
                                    }} 
                                />
                                <Skeleton.Input 
                                    active 
                                    style={{ 
                                        width: '80px',
                                        height: '10px',
                                        borderRadius: '4px',
                                        background: '#e5e7eb',
                                        border: 'none'
                                    }} 
                                />
                            </div>
                            <Skeleton.Avatar 
                                active 
                                size={14} 
                                shape="circle"
                                style={{
                                    background: '#e5e7eb',
                                    border: 'none',
                                    flexShrink: 0
                                }}
                            />
                        </Space>
                    </div>

                    {/* Auction Name Section Skeleton */}
                    <div style={{
                        marginTop: '8px',
                        padding: '12px',
                        background: '#f8fafc',
                        borderRadius: '10px',
                        border: '1px solid #e2e8f0'
                    }}>
                        <Space size={6} style={{ width: '100%', minWidth: 0 }}>
                            <Skeleton.Avatar 
                                active 
                                size={16} 
                                shape="circle"
                                style={{
                                    background: '#e2e8f0',
                                    border: 'none',
                                    flexShrink: 0
                                }}
                            />
                            <Skeleton.Input 
                                active 
                                style={{ 
                                    width: '100%',
                                    height: '14px',
                                    borderRadius: '4px',
                                    background: '#e2e8f0',
                                    border: 'none',
                                    flex: 1,
                                    minWidth: 0
                                }} 
                            />
                        </Space>
                    </div>
                </Space>
            </div>
        </Card>
    );
};

export default BrowseLotCardSkeleton;

